export { default } from "./SharePageLayout";
export type { SharePageLayoutProps as ResourcePageLayoutProps } from "./SharePageLayout";
